(function($) {
  let _ = require("lodash");

  let Register = function(element, options) {
    let elem = $(element);
    let obj = this;
    let settings = $.extend(
      {
        id: null,
        token: null,
        countryId: null, // default country id
        model: null,
        defaultRow: null,
        fields: null,
        currency: 'RM',
        urls: {}
      },
      options || {}
    );

    let variant = null;

    /*
     * Public method
     * Can be called outside class
     */
    this.index = function() {
      $(".container").on('click', '#add-delegate', function() {
//      var li    = $('#delegates li.sortable-row:first');
        var clone = $(settings.defaultRow);

        var ids = [];

        $.each($('.company-delegate'), function(index, value) {
          ids.push($(this).data('id'));
        });

        var newId = (ids.length > 0) ? Math.max.apply(Math, ids) + 1 : 1;

        clone.attr('data-id', newId).data('id', newId);
        clone.find('.delegate-num').html(sprintf('%02d',(newId+1)));

        $.each(settings.fields, function(k, v) {
          clone.find(':input.delegate-'+k).prop('name', sprintf('delegates[%d]['+k+']', newId));
        });

//         clone.find('div.link-value :input:not(.dropdown-query):not(:button)').prop('name', sprintf('links[%d][value]', newId));

        $('#delegates').append(clone.show('highlight'));

        return false;
      });

      $("#container").on('click', '.remove-delegate', function() {
        $(this).closest('.company-delegate').remove();

        removeDelegateCallback();

        return false;
      });

      $('#container').on('change', ':input.delegate-food', function(e) {
        remarksCallback($(this));
      });

      $('#container').on('change', '.delegate-include-spouse', function (evt) {
        spouseChangeCallback($(this));
      });

      $('form#formo').on('submit', function(evt) {
        $.fancybox.open($('#loader'), {
          closeBtn: false,
          modal: true,
          // margin: [15, 15, 15, 15],
          // baseClass: 'fancybox-loader',
          // parentEl: $('.register-content:first'),,
        });

        new Spinner({
          color: '#fff',
          top: '30%'
        }).spin($('#loader .spin')[0]);
      });

      remarksCallback($('input.delegate-food:checked'));
      removeDelegateCallback();
      spouseChangeCallback($('.delegate-include-spouse:first'));
    };

    function spouseChangeCallback($el) {
      if ($el.is(':checked')) {
        $el.closest('.card-spouse').find('.card-body').show();
        $('#row-fees-spouse').show();
      } else {
        $el.closest('.card-spouse').find('.card-body').hide();
        $('#row-fees-spouse').hide();
      }

      $total = 0;

      $('.row-fees:visible').each(function (k, item) {
        $total += parseFloat($(item).data('amount'));
      })

      $('#fees-final-total').text(`${settings.currency} ${$total.toFixed(2)}`);
    }

    function remarksCallback($e) {
      var $input;
//     console.info($e);
      $.each($e, function(k, v) {
        $input = $(v).parents('.input-inline:first').find("input.remarks");
//         console.info($input);

        if($input.length > 0) {
          if($(v).val() == 'others')
            $input.removeClass('disabled').attr('disabled', false);
          else
            $input.addClass('disabled').attr('disabled', true);
        }
      });
    }

    function removeDelegateCallback() {
      var count = $(".company-delegate .section-title").length;

      if(count == 1)
        $(".company-delegate:first .section-title .remove-delegate").hide();
      else
        $(".company-delegate:first .section-title .remove-delegate").show();

      //(count < 3) ? $('.btn.add-option').closest('div').show() : $('.btn.add-option').closest('div').hide();
    }
  };

  $.register = function(options) {
    return new Register(null, options);
  };
})(jQuery);
